function loginTracker(){

  const install = {};

  /** **************************************************************************
   *  get - - - - - - - - one event from queue and return parsed obj based on event type.
   *
   *
   *  @param    {(Object)}   qone  - One event from queue.
   *  @param    {(Object)}   definitions  - Default parameters.
   *  @returns   {(Object)}   Parsed event.
   *  @example install.schemaParser().
   *
   ************************************************************************** */
  install.schemaParser = function(qone, definitions) {
    // store tracker function, to have quick access to it
    const trFn = window[window.GPtracker].tr;
    const defs = definitions;
    /**
     * Description of arguments in every function
     *
     * every function has two arguments, defs and args
     * defs is a obj with "default", common values for all events
     * args is array of arguments from event call
     *
     * available options in defs obj:
     * clientDeviceType: ex: "desktop",
     * clientOs: ex: "linux",
     * url: ex: "http://www.pracuj.pl",
     * referrer: ex: "http://www.google.com",
     * businessId: ex: 1234561973,
     * previousPageviewId: ex: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
     * trackingId: ex: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx",
     * callback": ex: function(e){console.log(e)},
     * urlQuery": getUrlVars(_window.location.href),
     * pageViewId": ex: "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx"
     *
     * example args
     * {'0':'send','1':'pageview','2':{'offerId':21326884,'applyUrl':'google.com','appType':'direct'}}
     * this obj is returned by calling the gptr('send', 'pageview', {'offerId':21326884,'applyUrl':'google.com','appType':'direct'})
     * args can look like this as well
     * {'0':'send','1':'offerviewclisk','2':'21326884','3':'google.com','4':'direct'}
     * returned by gptr('send', 'offerviewclisk', '21326884', 'google.com', 'direct')
     * you dont need to parse tkis obj to more readable format you can simply pass args through setArgs function with array of instructions and return simply key val pairs
     * like this:
     * trFn.setArgs(args,[{'offerId':'int'}]);
     * trFn is defined few lines above it's simply reference tro main tracker class
     * args is arguments as defined above, second parameter is instructions
     * instructions is array with object where each object contains one key val pair
     * key is our name for example offerID and value is type
     * the order in array is very important, it represent the order of arguments in gptr function
     * the order in array represent the arguments order in gptr function
     * example:
     * gptr('send', 'pageview', {'offerId':21326884,'applyUrl':'google.com','appType':'direct'})
     * is equal to:
     * gptr('send', 'pageview', 21326884, 'google.com', 'direct')
     * as you can see offerID is equal to third param in short version, applyUrl of fourth, and so on.
     */

    function sendPageview(args, uuid){
      const eventData = {
        'schema': 'iglu:pl.pracuj.tracker/pageview/jsonschema/2-0-0',
        'data': {}
      };

      if (defs.previousPageviewId) eventData.data.previousPageviewId = defs.previousPageviewId;

      // store newv PageviewID, you can acces it later in future events by defs.previousPageviewId
      trFn.setPVID(uuid);

      return {
        request: eventData,
        hasImportant: false
      };
    }

    function returnInvalid(){
      return { request: false, hasImportant: false };
    }

    const payload = {
      'pageview': sendPageview,
      'invalid': returnInvalid
    };

    return (payload[qone.args[1]] || payload.invalid)(defs, qone, qone.uuid, qone.ts);
  };

  /** **************************************************************************.
   *
   *  Get user businessId.
   *
   *  @returns   {(string)} session id for this user ex: '1492155783' or false if not logged in.
   *  @example   getBusinessId()
   *
   ************************************************************************** */

  install.getBusinessId = function() {
    if (window.user && window.user.isLoggedIn && window.user.userId && window.user.userId !== '0') {
      return window.user.userId;
    } else if (window.userId) {
      return window.userId;
    }
    return false;
  };

  function getAuthToken(){
    const trFn = window[window.GPtracker].tr;
    return trFn.getCookie('_gpauth');
  }

  function checkIfTrackerLoaded(){
    if  (window[window.GPtracker] && typeof window[window.GPtracker].tr !== 'undefined' && typeof window[window.GPtracker].tr.isLoaded === 'function'){
      return window[window.GPtracker].tr.isLoaded();
    }
    return false;
  }

  function trackerBusinessInstall(){
    if (checkIfTrackerLoaded()) {
      install.defaults = {
        businessId: install.getBusinessId()
      };
      const AuthToken = getAuthToken();
      if (AuthToken) install.authToken = AuthToken;
      window[window.GPtracker].tr.install(install);
    } else {
      setTimeout(trackerBusinessInstall,100);
    }
  }
  trackerBusinessInstall();
}

loginTracker();
